/* assets/zendesk-search-redirect.js */
// Zendesk redirect UITGESCHAKELD – deze versie doet helemaal niets meer qua redirect.

(function () {
  console.log('[Zendesk redirect script gedeactiveerd]');
})();
